export enum TeamSectionEnum {
  Recruiters = 'members',
}
